import {
    Box,
    Divider,
    Drawer,
    Icons,
    List,
    ThemeColorVariable,
    ThemeSpaceVariable,
    useDisclosure,
} from "@caspeco/casper-ui-library";
import { PrivacyPolicyModal } from "components/privacy-policy-modal";
import LanguageModal from "components/side-navigation/language-modal";
import { PoweredByCaspeco } from "components/side-navigation/powered-by-caspeco";
import { SideNavigationMenuButton } from "components/side-navigation/side-navigation-menu-button";
import { getNameOfCurrentLang } from "helpers/language-helper";
import { useTranslation } from "react-i18next";
import { SideNavigationHeader } from "./side-navigation-header";

interface ISideNavigation {
    onCloseSideNav: () => void;
    isSideNavOpen: boolean;
    isLeftAligned?: boolean;
}

const SideNavigation = ({ onCloseSideNav, isSideNavOpen, isLeftAligned }: ISideNavigation) => {
    const { t } = useTranslation();
    const {
        isOpen: languageModalIsOpen,
        onOpen: openLanguageModal,
        onClose: closeLanguageModal,
    } = useDisclosure({
        onOpen: onCloseSideNav,
    });
    const { isOpen: privacyPolicyModalIsOpen, onToggle: togglePrivacyPolicyModal } = useDisclosure({
        onOpen: onCloseSideNav,
    });

    return (
        <>
            <LanguageModal onClose={closeLanguageModal} isOpen={languageModalIsOpen} />
            <PrivacyPolicyModal
                isOpen={privacyPolicyModalIsOpen}
                onClose={togglePrivacyPolicyModal}
            />

            <Drawer
                isOpen={isSideNavOpen}
                onClose={onCloseSideNav}
                placement={isLeftAligned ? "left" : "right"}
                size="xs"
                bg={ThemeColorVariable.Background}
            >
                <SideNavigationHeader onClose={onCloseSideNav} />
                <Box
                    as="aside"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    flex="1"
                    h="100%"
                    color={ThemeColorVariable.OnBackground}
                >
                    <List>
                        <SideNavigationMenuButton
                            onClick={openLanguageModal}
                            areaLabel={t("miscChangeLanguage")}
                            icon={Icons.Language}
                            text={t("miscXLanguage", { 0: getNameOfCurrentLang() })}
                            trackingId="sidenav-language"
                        />
                        <SideNavigationMenuButton
                            onClick={togglePrivacyPolicyModal}
                            icon={Icons.File}
                            text={t("privacyPolicy")}
                            trackingId="sidenav-privacypolicy"
                        />
                        <Box p={ThemeSpaceVariable.Medium}>
                            <Divider />
                        </Box>
                        <Box
                            display="flex"
                            gap={ThemeSpaceVariable.Small}
                            px={ThemeSpaceVariable.Medium}
                        >
                            <PoweredByCaspeco />
                        </Box>
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default SideNavigation;
